import {Box, BoxProps} from "@mui/material";
import {colors, radii, shadows} from "../theme";
import {Text, Container, TextVariant} from ".";

type Size = "lg" | "md";

interface SizeMap {
  ratio: number;
  textVariant: TextVariant;
  border: string;
  shadow?: string;
}

const sizeMap: Record<Size, SizeMap> = {
  lg: {ratio: 44, textVariant: "heading-lg", border: colors.tertiary[200], shadow: shadows.partnerLogo},
  md: {ratio: 40, textVariant: "display-body", border: colors.tertiary[300]},
};

type PartnerLogoProps = {
  url?: string;
  name?: string;
  size?: Size;
  sx?: BoxProps["sx"];
};

export const PartnerLogo = ({url, name, size = "lg", sx}: PartnerLogoProps) => {
  const theme = sizeMap[size];
  return (
    <Container
      center
      sx={{
        width: theme.ratio,
        height: theme.ratio,
        flexShrink: 0,
        borderRadius: radii.xxs,
        boxShadow: theme.shadow,
        border: `1px solid ${theme.border}`,
        overflow: "hidden",
        ...sx,
      }}
    >
      {url ? (
        <Box component="img" src={url} alt={name} sx={{width: "100%", height: "100%", objectFit: "contain"}} />
      ) : (
        <Text variant={theme["textVariant"]}>{name?.[0]?.toLocaleUpperCase()}</Text>
      )}
    </Container>
  );
};
